export const initialState = {
    searchQuery: ""
};
